import { Maybe } from '../../../__generated__/globalTypes'

import { Amount, isAmount } from './Amount'

import { Price, isPrice } from './Price'

import giftVariationFragmentRawString from '../GiftVariationFragment.graphql'

export const giftVariationFragmentString = giftVariationFragmentRawString

export type GiftVariationFragment = {
  id: string
  name: string
  description: Maybe<string>
  contents: Maybe<string>
  shipping: Maybe<string>
  points: Amount
  imageUrls: string[]
  packaging: Maybe<string>
  price: Price
  defaultImageUrl: string
}

export const isGiftVariationFragment = (
  fragment: any,
): fragment is GiftVariationFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.name === 'string' &&
  (fragment.description === null || typeof fragment.description === 'string') &&
  (fragment.contents === null || typeof fragment.contents === 'string') &&
  (fragment.shipping === null || typeof fragment.shipping === 'string') &&
  (isAmount(fragment.points) as boolean) &&
  Array.isArray(fragment.imageUrls) &&
  fragment.imageUrls
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && typeof next === 'string',
      true,
    ) &&
  (fragment.packaging === null || typeof fragment.packaging === 'string') &&
  (isPrice(fragment.price) as boolean) &&
  typeof fragment.defaultImageUrl === 'string'
